<template>
  <div v-if="content !== ''" class="text-wrapper ql-editor" v-html="content" :style="textStyle">
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    defaultFont: {
      type: String,
      default: 'inherit'
    }
  },
  computed: {
    textStyle() {
      return {
        'font-family': this.defaultFont,
        'padding': '10px 15px!important'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Text.vue